import { entityFiltersService } from '../services/entity_filters';
import { entityFiltersFormatter } from '../formatters/entity_filters';
import { entityFiltersConstants } from '../constants/entity_filters';

export const entityFiltersActions = {
  getEntityFilter,
  getAllEntityFilters,
  updateEntityFilter,
  createFilter,
  destroyFilter
}

function destroyFilter(id){
  return (dispatch, getState) => {
    dispatch(request());

    return entityFiltersService.destroyFilter(id)
    .then( response => {
      dispatch(success(response.data));
      return true;
    })
    .catch( error => {
      dispatch(failure(error));
    });
  }

  function request() { return { type: entityFiltersConstants.DESTROY_ENTITY_FILTER_REQUEST }};
  function success(payload) { return { type: entityFiltersConstants.DESTROY_ENTITY_FILTER_SUCCESS, payload }};
  function failure(payload) { return { type: entityFiltersConstants.DESTROY_ENTITY_FILTER_FAILURE, payload }};
}

function createFilter(params){
  return dispatch => {
    dispatch(request());

    return entityFiltersService.createFilter(params)
    .then( response => {
      dispatch(success(response.data, params.entity));
      return response.data;
    })
    .catch( error => {
      dispatch(failure(error));
    })
  }

  function request() { return { type: entityFiltersConstants.CREATE_ENTITY_FILTER_REQUEST }};
  function success(payload, entity) { return { type: entityFiltersConstants.CREATE_ENTITY_FILTER_SUCCESS, payload, entity}};
  function failure(payload) { return { type: entityFiltersConstants.CREATE_ENTITY_FILTER_FAILURE, payload }};
}

function getEntityFilter(id){
  return dispatch => {
    dispatch(request());

    return entityFiltersService.getEntityFilter(id)
    .then( response => {
      dispatch(success(response.data));
      return response.data;
    })
    .catch( error => {
      dispatch(failure(error));
    })
  }
  function request() { return { type: entityFiltersConstants.GET_ENTITY_FILTER_REQUEST }};
  function success( payload ) { return { type: entityFiltersConstants.GET_ENTITY_FILTER_SUCCESS, payload }};
  function failure( payload  ) { return { type: entityFiltersConstants.GET_ENTITY_FILTER_FAILURE, error: payload }};
}

function updateEntityFilter(id, filter){
  return dispatch => {
    dispatch(request());

    return entityFiltersService.updateEntityFilter(id, filter)
    .then( response => {
      const filter = response.data;
      dispatch(success(filter));
      return filter;
    })
    .catch( error => {
      dispatch(failure(error));
    });
  }
  function request() { return { type: entityFiltersConstants.UPDATE_ENTITY_FILTER_REQUEST }};
  function success( payload) { return { type: entityFiltersConstants.UPDATE_ENTITY_FILTER_SUCCESS, payload }};
  function failure( payload ) { return { type: entityFiltersConstants.UPDATE_ENTITY_FILTER_FAILURE, error: payload }};
}

function getAllEntityFilters(){
    return (dispatch, getState) => {
      dispatch(request());
      const currentUser = getState().user.user;

      return entityFiltersService.getAllEntityFilters()
      .then( response => {
        const data = entityFiltersFormatter.formatAllEntityFilters(response.data, currentUser);           
        dispatch(success(data));
        return data;
      })
      .catch( error => {
        dispatch(failure(error));
      })
    }
    function request(entity) { return { type: entityFiltersConstants.GET_ALL_ENTITY_FILTERS_REQUEST, entity }};
    function success( payload ) { return { type: entityFiltersConstants.GET_ALL_ENTITY_FILTERS_SUCCESS, payload }};
    function failure( payload ) { return { type: entityFiltersConstants.GET_ALL_ENTITY_FILTERS_FAILURE, error: payload }};
  }
